// src/components/Dashboard.jsx
import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import OttiGrid from "./OttiGrid";
import IntexAssumptions from "./IntexAssumptions";
import CommentTemplatesGrid from "./CommentTemplatesGrid";

const Dashboard = ({ userId }) => {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      <Tabs
        value={tab}
        onChange={(_e, v) => setTab(v)}
        sx={{ borderBottom: 1, borderColor: "divider", px: 2, flexShrink: 0 }}
      >
        <Tab label="Impairments" />
        <Tab label="Comment Templates" />
      </Tabs>

      {/* Both panels stay mounted (hidden, not unmounted) so switching tabs
          never discards unsaved OTTI grid edits or reloads its data. */}
      <Box
        sx={{
          display: tab === 0 ? "flex" : "none",
          flexDirection: "column",
          gap: 3,
          p: 2,
          overflow: "auto",
        }}
      >
        <OttiGrid userId={userId} />
        <IntexAssumptions userId={userId} />
      </Box>

      <Box sx={{ display: tab === 1 ? "block" : "none", p: 2, overflow: "auto" }}>
        <CommentTemplatesGrid userId={userId} />
      </Box>
    </Box>
  );
};

export default Dashboard;
